var _rect, _circle, _path, _circle2, _path2, _path3, _path4, _path5, _path6, _circle3, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientConnectivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 32,
    viewBox: "0 0 176 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 28,
    height: 28,
    rx: 7.724,
    fill: "#E8DEF1",
    stroke: "#510C76"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.003,
    cy: 15.517,
    r: 3.862,
    fill: "#fff",
    stroke: "#510C76"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.227 14.201 1.546 2.633",
    stroke: "#510C76",
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.997,
    cy: 22.276,
    r: 0.5,
    fill: "#510C76",
    stroke: "#510C76",
    strokeWidth: 0.931
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#500D76",
    strokeDasharray: "2 2",
    d: "M34 15.5h40M101 15.5h40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M171.445 3h-22.001A2.444 2.444 0 0 0 147 5.444v14.667a2.444 2.444 0 0 0 2.444 2.445H171.445a2.444 2.444 0 0 0 2.444-2.445V5.444A2.444 2.444 0 0 0 171.445 3z",
    fill: "#EDE3F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M148.444 27.445h22.778m-6.111-4.89v4.89M149.444 3h22.001a2.444 2.444 0 0 1 2.444 2.444v14.667a2.444 2.444 0 0 1-2.444 2.445h-22.001A2.444 2.444 0 0 1 147 20.11V5.444A2.444 2.444 0 0 1 149.444 3z",
    stroke: "#500D76",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M161.14 11.556h-8.73c-.964 0-1.746.766-1.746 1.71v13.69c0 .945.782 1.71 1.746 1.71h8.73c.965 0 1.746-.765 1.746-1.71v-13.69c0-.944-.781-1.71-1.746-1.71z",
    fill: "#EDE3F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M156.775 25.244h.009m-4.374-13.688h8.73c.965 0 1.746.766 1.746 1.71v13.69c0 .945-.781 1.71-1.746 1.71h-8.73c-.964 0-1.746-.765-1.746-1.71v-13.69c0-.944.782-1.71 1.746-1.71z",
    stroke: "#500D76",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.997,
    cy: 25.276,
    r: 0.5,
    fill: "#510C76",
    stroke: "#510C76",
    strokeWidth: 0.931
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.862 16.468a2.618 2.618 0 1 1-5.237 0 2.618 2.618 0 0 1 5.237 0z",
    fill: "#E8DEF1",
    stroke: "#510C76",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.466 20.025a5.345 5.345 0 0 1 0-7.56m7.56 0a5.346 5.346 0 0 1 0 7.56m-9.292 1.733a7.795 7.795 0 0 1 0-11.025m11.025 0a7.796 7.796 0 0 1 0 11.025M81 23.49a10.246 10.246 0 0 1 0-14.49m14.49 0a10.246 10.246 0 0 1 0 14.49",
    stroke: "#510C76",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientConnectivity);
export default __webpack_public_path__ + "static/media/clientConnectivity.f887e1bd96477274ce6d3b057efcf5a4.svg";
export { ForwardRef as ReactComponent };